export default {
  SET_EXPERIMENTS: 'SET_EXPERIMENTS',
  SET_ID: 'SET_ID',
  SET_MOBILE: 'SET_MOBILE',
  SET_INTERSTITIAL_SEEN: 'SET_INTERSTITIAL_SEEN',
  SET_ALERT_SEEN: 'SET_ALERT_SEEN',
};
